import axios from 'axios';
import webservice, { MobileServicePath } from '../../../../services/webservice';

class APIAnalyticsService {
    getBaseUrl(isMobile) {
        return isMobile ? MobileServicePath : webservice;
    }

    getAnalyticsBaseUrl(isMobile) {
        return `${this.getBaseUrl(isMobile)}api/analytics`;
    }

    getSummary(filters = {}, isMobile = false) {
        return axios.get(`${this.getAnalyticsBaseUrl(isMobile)}/summary`, { params: filters });
    }

    getTrends(filters = {}, interval = 'day', isMobile = false) {
        return axios.get(`${this.getAnalyticsBaseUrl(isMobile)}/trends`, { 
            params: { ...filters, interval } 
        });
    }

    getApisList(filters = {}, sortBy = 'calls', limit = 10, isMobile = false) {
        return axios.get(`${this.getAnalyticsBaseUrl(isMobile)}/apis`, { 
            params: { ...filters, sortBy, limit } 
        });
    }

    getLatestRequests(filters = {}, limit = 12, isMobile = false) {
        return axios.get(`${this.getAnalyticsBaseUrl(isMobile)}/latest`, { 
            params: { ...filters, limit } 
        });
    }

    // Server Monitoring
    // getServerStatus() {
    //     return axios.get(`${webservice}api/server/status`);
    // }

    getServerMetrics(isMobile = false) {
        return axios.get(`${this.getBaseUrl(isMobile)}api/server/metrics`);
    }

    // getServerActionHistory(limit = 10) {
    //     return axios.get(`${webservice}api/server/action-history`, { params: { limit } });
    // }

    // performServerAction(action) {
    //     return axios.post(`${webservice}api/server/action`, { action });
    // }

    // Additional methods can be added for specific status/performance charts if needed
}

export default new APIAnalyticsService();
